import React, { Suspense, useEffect, useRef, useState } from "react";
import CompletionSubHeader from "../header/CareersSubHeader";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { getJobList, getSearchData, getJobDetails, loderControl, loderControlFalse, getQuestionList, searchJobScroll, clearJobTileFilterRequest, clearActiveJobTile } from "../../../redux/slices/careersSlices.reducer";
import { displayPage, monthNames, sortList } from "../../../config/careers/careers";
import Loader from "../../../component/loader/Loader";
import makeAnimated from "react-select/animated";
import JobFilter from "./JobFilter";
import { publishingDate } from "./CareersFucConfig";
import { clientIds, optionThreeClients } from "../../../config/clients/clients";
import JobListingsSplit from "./JobListingsSplit";
import JobListingsClient from "./JobListingsClient";
import OptionThreeJobListing from "./OptionThree/OptionThreeJobListing";
import OptionThreeJobFilter from "./OptionThree/OptionThreeJobFilter";
import useClientConfig from "../../../config/careers/clientConfig";
import OptionFourJobListing from "./OptionFour/OptionFourJobListing";
import OptionFourJobFilter from "./OptionFour/OptionFourJobFilter";
import JobFilterClient from "./JobFilterClient";
const SkyJobListing = React.lazy(() => import("./Sky/SkyJobListing"));
const SkyJobFilter = React.lazy(() => import("./Sky/SkyJobFilter"));
const EditorialMonoJobListing = React.lazy(() => import("./EditorialMono/EditorialMonoJobListing"));
const EditorialMonoJobFilter = React.lazy(() => import("./EditorialMono/EditorialMonoJobFilter"));
const GlassAuroraJobListing = React.lazy(() => import("./GlassAurora/GlassAuroraJobListing"));
const GlassAuroraJobFilter = React.lazy(() => import("./GlassAurora/GlassAuroraJobFilter"));
const OptionSixJobListing = React.lazy(() => import("./OptionSix/OptionSixJobListing"));
const PremiumJobListing = React.lazy(() => import("./PremiumTemplate/PremiumJobListing"));

const JobListings = () => {
    const animatedComponents = makeAnimated();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const routeParams = useParams();
    const jobsList = useSelector((state: any) => state.careers.allJobList);
    const allSearchData = useSelector((state: any) => state.careers.allSearchData);
    const loader = useSelector((state: any) => { return state?.careers?.loading; });
    const questionId = useSelector((stete: any) => { return stete?.careers?.getQuestionId; });
    const jobListScroll = useSelector((stete: any) => { return stete?.careers?.jobListScroll; });
    const clientConfig = useSelector((state: any) => state.careers.cliendConfig);
    const settingsLoaded = useSelector((state: any) => state.careers.settingsLoaded);
    const jobTileFilterRequest = useSelector((state: any) => state.careers.jobTileFilterRequest);
    const [isGeoLocationNecessary, setIsGeoLocationNecessary] = useState(true);
    const langLabels = clientConfig?.data?.data?.clientSettings?.languageSettings;
    const jobListingLangLabels = langLabels?.jobListing?.[0];
    const { clientSiteSettings } = useClientConfig();


    const [tableControl, setTableControl] = useState<any>({
        currentPage: 1,
        totalCount: "",
        pageSize: displayPage[1],
        searchText: "",
        searchCat: [],
        searchJob: [],
        searchLocation: [],
        postCode: "",
        distanceRadius: "",
        jobListAPiCall: "",
        data: [],
        massage: "",
        sort: sortList[0]
    });

    const [filterListData, setFilterSetData] = useState({
        jobCategories: null,
        jobLocations: null,
        jobTypes: null,
        jobDistances: null
    });
    const [listView, setListView] = useState("list");

    const [closeAll, setCloseAll] = useState(false);
    const [removeFilterData, setRemoveFilterData] = useState(false);
    const [checkListControl, setCheckListControl] = useState<boolean>(false);
    const [browserLocation, setBrowserLocation] = useState<any>({});
    const [filterViews, setfilterViews] = useState({
        filterView: false,
        listAndMapView: false
    });
    const jobListDev: any = useRef(null);
    // const [scrollValue, setScrollValue] = useState(0);
    const [clientDesign, setClientDesign] = useState("");
    const [locationAccess, setLocationAccess] = useState<boolean>(false);
    const [withinDisabled, setWithinDisabled] = useState<boolean>(true);
    const [withinDisabledLocClass, setWithinDisabledLocClass] = useState("");
    const [apiLoad, setApiLoad] = useState(false);
    const [pendingUrlSearch, setPendingUrlSearch] = useState(false);
    const urlFilterPendingRef = useRef(false);
    const skipPageEffectRef = useRef(false);
    const pendingParamsOverrideRef = useRef<any>(null);
    const templateName = clientSiteSettings?.templateName;

    const activeClient = useSelector((state: any) => {
        return state?.careers?.activeClient;
    });

    useEffect(() => {
        document.body.classList.remove("apply-job-page");
        document.body.classList.remove("view-job-page");
        document.body.classList.add("career-page");
    }, []);

    const checkClientDesign = () => {
        if (templateName === "template_4" || templateName === "template_9") {
            setClientDesign("template_4");
        } else {
            setClientDesign("common");
        }

        if (clientSiteSettings?.optionThreeClient === true) {
            setClientDesign("option3");
        }

        if (templateName === "gre") {
            setClientDesign("option4");
        }

        if (templateName === "template_5" || clientSiteSettings?.skyBreezeTheme === true) {
            setClientDesign("skyTheme");
        }
        if (clientSiteSettings?.editorialMonoClient === true) {
            setClientDesign("editorialMono");
        }
        if (clientSiteSettings?.glassAuroraClient === true) {
            setClientDesign("glassAurora");
        }

        if (templateName === "template_6" || clientSiteSettings?.optionSixClient === true) {
            setClientDesign("option6");
        }
        if (templateName === "premium_template" || clientSiteSettings?.premiumTemplateClient === true) {
            setClientDesign("premium");
        }
    };

    useEffect(() => {
        checkClientDesign();
    }, [clientConfig]);

    useEffect(() => {

        // if (activeClient?.length > 0) {
        if (templateName === "template_9" && (location.pathname === "/" || location.pathname === "/jobs")) {
            document.body.classList.remove("job-view-body");
            document.body.classList.remove("job-apply-body");
        }
        // }
    }, [activeClient]);

    useEffect(() => {
        if ((location.pathname === "/" || location.pathname === "/jobs" || location.pathname.includes("/view/")) && settingsLoaded === true) {
            setApiLoad(true);
        } else {
            setApiLoad(false);
        }
    }, [location.pathname, settingsLoaded]);

    useEffect(() => {
        if (allSearchData?.status === 200) {
            if (allSearchData.data.statusCode === 200) {
                setFilterSetData((prs) => {
                    return {
                        ...prs,
                        jobCategories: allSearchData?.data?.data?.jobCategories.map((ress: any) => {
                            return {
                                ...ress,
                                value: ress.jobCategoryId,
                                label: ress.categoryName
                            };
                        }),
                        jobLocations: allSearchData?.data?.data?.jobLocations.map((ress: any) => {
                            return {
                                ...ress,
                                value: ress.jobLocationId,
                                label: ress.locationName
                            };
                        }),
                        jobTypes: allSearchData?.data?.data?.jobTypes.map((ress: any) => {
                            return {
                                ...ress,
                                value: ress.jobTypeId,
                                label: ress.typeName
                            };
                        }),
                        jobDistances: allSearchData?.data?.data?.jobDistances.map((ress: any) => {
                            return {
                                ...ress,
                                value: ress.distance,
                                label: ress.distanceLabel
                            };
                        }),
                    };
                });

                //set value in localstorage
                localStorage.setItem("jobCategories", JSON.stringify(allSearchData?.data?.data?.jobCategories));
            }
        }
    }, [allSearchData]);

    const pageChange = (params: number | string) => {
        setTableControl((prs: any) => {
            return {
                ...prs,
                currentPage: params
            };
        });
        // window.scroll(0, jobListScroll);
        setTimeout(function () { window.scrollTo(0, jobListScroll); }, 1);
    };

    /* A raw "&" in a URL splits the query string, so a label such as "Sales & Marketing" is written as "category=sales and marketing".. */
    const normaliseLabel = (value: string) => {
        return String(value)
            .toLowerCase()
            .replace(/&/g, " and ")
            .replace(/\s+/g, " ")
            .trim();
    };

    const matchOptionsByLabel = (options: any[] | null, rawValue: string | null) => {
        if (!rawValue || !options) {
            return [];
        }
        const wantedLabels = rawValue.split(";").map((val) => normaliseLabel(val)).filter(Boolean);
        return options.filter((option: any) => wantedLabels.includes(normaliseLabel(option.label)));
    };

    const clearStoredSearch = () => {
        sessionStorage.removeItem("jobsearchtext");
        sessionStorage.removeItem("jobsearchCategory");
        sessionStorage.removeItem("jobsearchJobTypes");
        sessionStorage.removeItem("jobsearchlocation");
        sessionStorage.removeItem("jobsearchPostcode");
        sessionStorage.removeItem("jobsearchDistanceradius");
    };

    /* paramsOverride is used by the job filter tiles when the clicked value has
       no matching filter option: the value is sent as it is so the API answers
       with its regular "no jobs found" response instead of an unfiltered list. */
    const getListOfJob = async (paramsOverride?: any) => {
        const apiParams: any = {};
        const searchText = sessionStorage.getItem("jobsearchtext");
        const jobsearchCategory = sessionStorage.getItem("jobsearchCategory");
        const jobsearchJobTypes = sessionStorage.getItem("jobsearchJobTypes");
        const jobsearchlocation = sessionStorage.getItem("jobsearchlocation");
        const jobsearchPostcode = sessionStorage.getItem("jobsearchPostcode");
        const jobsearchDistanceradius = sessionStorage.getItem("jobsearchDistanceradius");
        if (tableControl.searchText || (searchText !== null && searchText)) {
            apiParams["searchKeyword"] = tableControl.searchText ? tableControl.searchText : searchText;
        }
        if (tableControl.distanceRadius && Object.keys(tableControl.distanceRadius)?.length > 0 && "distance" in tableControl.distanceRadius) {
            apiParams["distance"] = tableControl.distanceRadius?.distance;
            apiParams["latitude"] = browserLocation?.coords?.latitude;
            apiParams["longitude"] = browserLocation?.coords?.longitude;
        } else {
            if (jobsearchDistanceradius && jobsearchDistanceradius !== null && Object.keys(JSON.parse(jobsearchDistanceradius))?.length > 0) {
                apiParams["distance"] = JSON.parse(jobsearchDistanceradius)?.distance;
                apiParams["latitude"] = browserLocation?.coords?.latitude;
                apiParams["longitude"] = browserLocation?.coords?.longitude;
            }
        }
        if (tableControl.searchCat.length > 0) {
            apiParams["categoryId"] = tableControl.searchCat.map((ress: any) => ress.jobCategoryId)?.toString();
        } else {
            if (jobsearchCategory && jobsearchCategory !== null && JSON.parse(jobsearchCategory)?.length > 0) {
                apiParams["categoryId"] = JSON.parse(jobsearchCategory)?.map((ress: any) => ress.jobCategoryId)?.toString();
            }
        }
        if (tableControl.searchLocation.length > 0) {
            apiParams["location"] = tableControl.searchLocation.map((ress: any) => ress.jobLocationId)?.toString();
        } else {
            if (jobsearchlocation && jobsearchlocation !== null && JSON.parse(jobsearchlocation)?.length > 0) {
                apiParams["location"] = JSON.parse(jobsearchlocation)?.map((ress: any) => ress.jobLocationId)?.toString();
            }

        }


        if (tableControl.searchJob.length > 0) {
            apiParams["jobType"] = tableControl.searchJob.map((ress: any) => ress.jobTypeId)?.toString();
        } else {
            if (jobsearchJobTypes && jobsearchJobTypes !== null && JSON.parse(jobsearchJobTypes)?.length > 0) {
                apiParams["jobType"] = JSON.parse(jobsearchJobTypes)?.map((ress: any) => ress.jobTypeId)?.toString();
            }
        }
        if (tableControl.sort) {
            apiParams["sort"] = tableControl.sort?.value;
        }
        if (tableControl.postCode || (jobsearchPostcode !== null && jobsearchPostcode)) {
            apiParams["postCode"] = tableControl.postCode ? tableControl.postCode : jobsearchPostcode;
        }
        apiParams["perPage"] = tableControl.pageSize?.value;
        apiParams["page"] = tableControl.currentPage;
        // apiParams["latitude"] = "";
        // apiParams["longitude"] = "";
        if (paramsOverride) {
            Object.assign(apiParams, paramsOverride);
        }
        const obj: any = {};
        obj["url"] = clientConfig?.data?.data?.clientSettings?.clientId;
        obj["params"] = apiParams;
        dispatch<any>(getJobList(obj));

        if (location.pathname !== "/" && location.pathname !== "/jobs" && localStorage.getItem("backtoresult") === "1") {
            localStorage.removeItem("backtoresult");
            navigate(clientSiteSettings?.hasCultureLandingPage ? "/jobs" : "/");
        }

        //if(sessionStorage.getItem("backtoresult") !== "1"){
        clearStoredSearch();
        sessionStorage.removeItem("backtoresult");
        // }

    };

    useEffect(() => {
        if (apiLoad === true) {
            if (!jobTileFilterRequest) {
                dispatch(clearActiveJobTile());
            }
            const searchText = sessionStorage.getItem("jobsearchtext");
            const jobsearchCategory = sessionStorage.getItem("jobsearchCategory");
            const jobsearchJobTypes = sessionStorage.getItem("jobsearchJobTypes");
            const jobsearchlocation = sessionStorage.getItem("jobsearchlocation");
            const jobsearchPostcode = sessionStorage.getItem("jobsearchPostcode");
            const jobsearchDistanceradius = sessionStorage.getItem("jobsearchDistanceradius");

            const urlParams = new URLSearchParams(location.search);
            /* "keyword" & "q" either is accepted for keyword search */
            const urlKeyword = clientConfig?.data?.data?.clientSettings?.isMicroSite === 1
                ? ""
                : (urlParams.get("keyword") || urlParams.get("q") || "").trim();
            if (urlKeyword) {
                sessionStorage.setItem("jobsearchtext", urlKeyword);
            }

            if (urlKeyword || searchText || jobsearchCategory || jobsearchJobTypes || jobsearchlocation || jobsearchPostcode || jobsearchDistanceradius) {
                setCheckListControl(true);
            }
            const updatedTableControl = { ...tableControl };
            updatedTableControl.searchText = urlKeyword ? urlKeyword : (searchText ? searchText : "");
            updatedTableControl.searchCat = jobsearchCategory !== null ? JSON.parse(jobsearchCategory) : [];
            updatedTableControl.searchJob = jobsearchJobTypes !== null ? JSON.parse(jobsearchJobTypes) : [];
            updatedTableControl.searchLocation = jobsearchlocation !== null ? JSON.parse(jobsearchlocation) : [];
            updatedTableControl.postCode = jobsearchPostcode ? jobsearchPostcode : "";
            updatedTableControl.distanceRadius = jobsearchDistanceradius !== null ? JSON.parse(jobsearchDistanceradius) : "";
            setTableControl(updatedTableControl);

            if (clientConfig?.data?.data?.clientSettings?.isMicroSite !== 1) {
                const hasUrlFilters = Boolean(urlParams.get("category") || urlParams.get("jobTypes") || urlParams.get("locations"));
                if (hasUrlFilters) {
                    // Defer the initial load until the filter option lists arrive so the URL values can be matched and applied in a single call.
                    urlFilterPendingRef.current = true;
                } else if (!jobTileFilterRequest) {
                    getListOfJob();
                }
                // A pending banner tile filter is applied by the effect below, which also loads the jobs.
                //
                dispatch<any>(getSearchData(clientConfig?.data?.data?.clientSettings?.clientId));

                dispatch<any>(getQuestionList());
            }

        }
    }, [apiLoad]);

    useEffect(() => {
        if (!urlFilterPendingRef.current) {
            return;
        }
        if (filterListData.jobCategories === null && filterListData.jobTypes === null && filterListData.jobLocations === null) {
            return;
        }

        urlFilterPendingRef.current = false;

        const urlParams = new URLSearchParams(location.search);
        const matchedCat = matchOptionsByLabel(filterListData.jobCategories, urlParams.get("category"));
        const matchedJobType = matchOptionsByLabel(filterListData.jobTypes, urlParams.get("jobTypes"));
        const matchedLocation = matchOptionsByLabel(filterListData.jobLocations, urlParams.get("locations"));

        if (matchedCat.length || matchedJobType.length || matchedLocation.length) {
            setCheckListControl(true);
        }

        setTableControl((prs: any) => {
            return {
                ...prs,
                searchCat: matchedCat.length ? matchedCat : prs.searchCat,
                searchJob: matchedJobType.length ? matchedJobType : prs.searchJob,
                searchLocation: matchedLocation.length ? matchedLocation : prs.searchLocation
            };
        });
        setPendingUrlSearch(true);
    }, [filterListData, location.search]);

    const tileFilterParam = (filterBy: string) => {
        if (filterBy === "location") {
            return "location";
        }
        if (filterBy === "jobType") {
            return "jobType";
        }
        return "categoryId";
    };

    const tileFilterOptions = (filterBy: string) => {
        if (filterBy === "location") {
            return filterListData.jobLocations;
        }
        if (filterBy === "jobType") {
            return filterListData.jobTypes;
        }
        return filterListData.jobCategories;
    };

    /* A job filter tile (banner) was clicked: push its value into the search
       panel state so the filter dropdowns show the selection, then reload.
       The request is left untouched on the job view route so it survives the
       navigation to the listing, where this component is mounted again. */
    useEffect(() => {
        if (!jobTileFilterRequest || (location.pathname !== "/" && location.pathname !== "/jobs")) {
            return;
        }
        const filterBy = jobTileFilterRequest?.filterBy ? jobTileFilterRequest.filterBy : "category";
        const isKeyword = filterBy === "keyword";
        const options = tileFilterOptions(filterBy);
        // Wait for the option lists, unless the search data came back without any.
        const optionsOnTheWay = !allSearchData?.status || Boolean(allSearchData?.data?.data);
        if (!isKeyword && options === null && optionsOnTheWay) {
            return;
        }

        const matched = isKeyword ? [] : matchOptionsByLabel(options, jobTileFilterRequest?.value);
        const unmatched = !isKeyword && matched.length === 0;
        dispatch(clearJobTileFilterRequest());

        if (unmatched) {
            /* Nothing to select in the filter panel, so the tile value goes
               straight to the API, which answers with its "no jobs" response. */
            console.warn(`No ${filterBy} filter option matches the job tile value "${jobTileFilterRequest?.value}"`);
            dispatch(clearActiveJobTile());
            pendingParamsOverrideRef.current = {
                [tileFilterParam(filterBy)]: jobTileFilterRequest?.value
            };
        }

        // A tile is a fresh start: every other filter is reset.
        clearStoredSearch();
        setCheckListControl(!unmatched);
        if (tableControl.currentPage !== 1) {
            // Stops the page/sort effect from firing a duplicate request for the same search.
            skipPageEffectRef.current = true;
        }
        setTableControl((prs: any) => {
            return {
                ...prs,
                currentPage: 1,
                searchText: isKeyword ? jobTileFilterRequest?.value : "",
                searchCat: filterBy === "category" ? matched : [],
                searchJob: filterBy === "jobType" ? matched : [],
                searchLocation: filterBy === "location" ? matched : [],
                postCode: "",
                distanceRadius: ""
            };
        });
        setPendingUrlSearch(true);
    }, [jobTileFilterRequest, filterListData, allSearchData, location.pathname]);


    useEffect(() => {
        dispatch(loderControl());
        if (jobListScroll > 0 && (location.pathname === "/" || location.pathname === "/jobs")) {
            setTimeout(() => {
                window.scrollTo(0, jobListScroll);
                dispatch(loderControlFalse());
            }, 1200);
        } else {
            // console.log("gghggg");

            setTimeout(() => {
                dispatch(loderControlFalse());
            }, 1200);
        }

    }, [jobListScroll]);
    const searchControlSubmit = () => {
        // The user is driving the filter panel now, so no tile is "the" selection anymore.
        dispatch(clearActiveJobTile());

        sessionStorage.setItem("jobsearchtext", tableControl.searchText);
        sessionStorage.setItem("jobsearchCategory", JSON.stringify(tableControl.searchCat));
        sessionStorage.setItem("jobsearchJobTypes", JSON.stringify(tableControl.searchJob));
        sessionStorage.setItem("jobsearchlocation", JSON.stringify(tableControl.searchLocation));
        sessionStorage.setItem("jobsearchPostcode", tableControl.postCode);
        sessionStorage.setItem("jobsearchDistanceradius", JSON.stringify(tableControl.distanceRadius));

        const listingPath = clientSiteSettings?.hasCultureLandingPage ? "/jobs" : "/";
        if (location.pathname !== listingPath) {
            navigate(listingPath);
            if (clientSiteSettings?.templateName !== "template_3") {
                window.scrollTo(0, 0);
            }

        } else {
            if (tableControl.currentPage === 2) {
                tableControl.currentPage = 1;
            }
            getListOfJob();
            setCheckListControl(true);
        }
    };

    useEffect(() => {
        if (skipPageEffectRef.current) {
            // The page reset came from a job filter tile, which loads the jobs itself.
            skipPageEffectRef.current = false;
            return;
        }
        const pageControl = Number(tableControl.totalCount) / tableControl.pageSize?.value;
        if (pageControl) {
            const checkFloorType = Math.floor(pageControl);
            const perPageCheck = checkFloorType + 1;
            if (checkFloorType === pageControl) {
                getListOfJob();
            } else {
                if (tableControl.currentPage > perPageCheck) {
                    setTableControl((prs: any) => {
                        return {
                            ...prs,
                            currentPage: perPageCheck
                        };
                    });
                } else {
                    getListOfJob();
                }

            }
        }
    }, [tableControl.pageSize?.value, tableControl.currentPage, tableControl.sort]);

    useEffect(() => {
        // dispatch<any>(loderControl());
        if (jobsList?.status === 200) {
            //  dispatch<any>(loderControlFalse());
            if (jobsList?.data?.statusCode === 200) {
                const data = jobsList?.data?.data?.jobs;
                setTableControl((prs: any) => {
                    return {
                        ...prs,
                        // data: data.items.map(async (data: any) => {
                        //     return {
                        //         ...data,
                        //         postedAt: await publishingDate(data.postedAt)
                        //     };
                        // }),
                        data: data.items,
                        totalCount: data.totalRecord,
                        massage: "",
                        // currentPage: Number(tableControl.currentPage) === data.currentPage ? tableControl.currentPage : data.perPage
                    };
                });
                if (jobListScroll === 0) {
                    dispatch(searchJobScroll(jobListDev?.current?.offsetHeight));
                }
            } else if (jobsList?.data?.statusCode === 400) {
                setTableControl((prs: any) => {
                    return {
                        ...prs,
                        data: [],
                        totalCount: 0,
                        massage: jobsList?.data?.message
                    };
                });
            }
        } else {
            if (jobsList?.status === 401) {
                // dispatch<any>(loderControl());
                // getListOfJob();
                navigate("/*");
            }

        }
    }, [jobsList]);

    useEffect(() => {
        if (removeFilterData) {
            setTableControl((prs: any) => {
                return {
                    ...prs,
                    searchLocation: [],
                    searchCat: [],
                    searchText: "",
                    searchJob: [],
                    postCode: "",
                    distanceRadius: ""
                };
            });


            // setTimeout(() => {
            // getListOfJob();
            // setRemoveFilterData(false);

            // }, 500);

        }
    }, [removeFilterData]);
    useEffect(() => {
        if (removeFilterData) {
            getListOfJob();
            setRemoveFilterData(false);
        }
        if (pendingUrlSearch) {
            getListOfJob(pendingParamsOverrideRef.current);
            pendingParamsOverrideRef.current = null;
            setPendingUrlSearch(false);
        }

    }, [tableControl]);

    const removeSearchForm = () => {
        setRemoveFilterData(true);
        setCheckListControl(false);
        dispatch(clearActiveJobTile());
    };

    const pageSizeChange = (e: any) => {
        setTableControl((prs: any) => {
            return {
                ...prs,
                pageSize: e
            };
        });
    };

    useEffect(() => {
        if (location.pathname === `/view/${routeParams?.id}`) {
            dispatch<any>(getJobDetails(routeParams?.id));
            window.scrollTo(0, 0);
        }
    }, [location.state]);



    const updateCat = (params: any) => {
        setTableControl((prs: any) => {
            return {
                ...prs,
                searchCat: params
            };
        });
    };


    const navigateToJob = () => {
        navigate(`/view/${questionId?.data?.data}/apply-job/register/from/direct`);
    };

    const navigateToJobAlerts = () => {
        navigate("/job-alerts");
    };


    const filterView = () => {
        return (
            <>
                {clientConfig?.data?.data?.clientSettings?.isMicroSite === "" || clientConfig?.data?.data?.clientSettings?.isMicroSite === undefined || clientConfig?.data?.data?.clientSettings?.isMicroSite === 0 ? (
                    <JobFilter navigateToJob={navigateToJob} navigateToJobAlerts={navigateToJobAlerts} checkListControl={checkListControl} filter={filterListData} tableControl={tableControl} setTableControl={setTableControl} removeSearchForm={removeSearchForm} searchControlSubmit={searchControlSubmit} />
                ) : null}
            </>
        );
    };

    const optionThreeFilterView = () => {
        return (
            <>
                {clientConfig?.data?.data?.clientSettings?.isMicroSite === "" || clientConfig?.data?.data?.clientSettings?.isMicroSite === undefined || clientConfig?.data?.data?.clientSettings?.isMicroSite === 0 ? (
                    <OptionThreeJobFilter navigateToJob={navigateToJob} navigateToJobAlerts={navigateToJobAlerts} checkListControl={checkListControl} filter={filterListData} tableControl={tableControl} setTableControl={setTableControl} removeSearchForm={removeSearchForm} searchControlSubmit={searchControlSubmit} />
                ) : null}
            </>
        );
    };

    const optionFourFilterView = () => {
        return (
            <>
                {clientConfig?.data?.data?.clientSettings?.isMicroSite === "" || clientConfig?.data?.data?.clientSettings?.isMicroSite === undefined || clientConfig?.data?.data?.clientSettings?.isMicroSite === 0 ? (
                    <OptionFourJobFilter navigateToJob={navigateToJob} navigateToJobAlerts={navigateToJobAlerts} checkListControl={checkListControl} filter={filterListData} tableControl={tableControl} setTableControl={setTableControl} removeSearchForm={removeSearchForm} searchControlSubmit={searchControlSubmit} />
                ) : null}
            </>
        );
    };

    const skyFilterView = () => {
        return (
            <Suspense fallback={<></>}>
                {clientConfig?.data?.data?.clientSettings?.isMicroSite === "" || clientConfig?.data?.data?.clientSettings?.isMicroSite === undefined || clientConfig?.data?.data?.clientSettings?.isMicroSite === 0 ? (
                    <SkyJobFilter navigateToJob={navigateToJob} navigateToJobAlerts={navigateToJobAlerts} checkListControl={checkListControl} filter={filterListData} tableControl={tableControl} setTableControl={setTableControl} removeSearchForm={removeSearchForm} searchControlSubmit={searchControlSubmit} />
                ) : null}
            </Suspense>
        );
    };
    const editorialMonoFilterView = () => {
        return (
            <Suspense fallback={<></>}>
                {clientConfig?.data?.data?.clientSettings?.isMicroSite === "" || clientConfig?.data?.data?.clientSettings?.isMicroSite === undefined || clientConfig?.data?.data?.clientSettings?.isMicroSite === 0 ? (
                    <EditorialMonoJobFilter navigateToJob={navigateToJob} navigateToJobAlerts={navigateToJobAlerts} checkListControl={checkListControl} filter={filterListData} tableControl={tableControl} setTableControl={setTableControl} removeSearchForm={removeSearchForm} searchControlSubmit={searchControlSubmit} />
                ) : null}
            </Suspense>
        );
    };
    const glassAuroraFilterView = () => {
        return (
            <Suspense fallback={<></>}>
                {clientConfig?.data?.data?.clientSettings?.isMicroSite === "" || clientConfig?.data?.data?.clientSettings?.isMicroSite === undefined || clientConfig?.data?.data?.clientSettings?.isMicroSite === 0 ? (
                    <GlassAuroraJobFilter navigateToJob={navigateToJob} navigateToJobAlerts={navigateToJobAlerts} checkListControl={checkListControl} filter={filterListData} tableControl={tableControl} setTableControl={setTableControl} removeSearchForm={removeSearchForm} searchControlSubmit={searchControlSubmit} />
                ) : null}
            </Suspense>
        );
    };
    const classicTemplateFilterView = () => {
    return (
        <Suspense fallback={<></>}>
            {(clientConfig?.data?.data?.clientSettings?.isMicroSite === "" ||
                clientConfig?.data?.data?.clientSettings?.isMicroSite === undefined ||
                clientConfig?.data?.data?.clientSettings?.isMicroSite === 0) &&
                clientSiteSettings?.classicTemplateFilterView === true   &&
                !location.pathname.includes("/view/") && (
                    <JobFilterClient
                        filterListData={filterListData}
                        tableControl={tableControl}
                        setTableControl={setTableControl}
                        searchControlSubmit={searchControlSubmit}
                        withinDisabled={withinDisabled}
                        withinDisabledLocClass={withinDisabledLocClass}
                    />
                )}
        </Suspense>
    );
};
    useEffect(() => {
        if (Object.keys(clientConfig).length > 0) {
            if (clientConfig?.data?.data?.clientSettings?.isMicroSite !== 1 && isGeoLocationNecessary) {
                if ("geolocation" in navigator) {
                    navigator.geolocation.getCurrentPosition(
                        (ress: any) => {
                            setBrowserLocation(ress);
                            setLocationAccess(true);
                        },
                        (error: any) => {
                            console.error("Error getting geolocation: ", error);
                            setLocationAccess(false);
                        }
                    );
                }
            }
        }
    }, []);

    /* Check if the location is enabled or not in browser */
    useEffect(() => {
        if (Object.keys(clientConfig).length > 0) {
            if (clientConfig?.data?.data?.clientSettings?.isMicroSite !== 1) {
                if (navigator.permissions && isGeoLocationNecessary) {
                    navigator.permissions.query({ name: "geolocation" }).then((permissionStatus) => {
                        // below condition is to check during onload
                        if (permissionStatus.state === "granted") {
                            setLocationAccess(true);
                        } else {
                            setLocationAccess(false);
                        }

                        // below onchange is to get during changes in the browser
                        permissionStatus.onchange = () => {
                            if (permissionStatus.state === "granted") {
                                setLocationAccess(true);
                            } else {
                                setLocationAccess(false);
                            }
                        };
                    }).catch((error) => {
                        console.error("Error querying geolocation permissions: ", error);
                        setLocationAccess(false);
                    });
                } else {
                    console.warn("Geolocation permissions API is not available in this browser.");
                    setLocationAccess(false);
                }
            }
        }
    }, []);

    const attemptLocation = () => {
        if (locationAccess) {
            setWithinDisabled(false);
            setWithinDisabledLocClass("");
        } else {
            setWithinDisabled(true);
            setWithinDisabledLocClass("disabled-location");
        }
    };

    useEffect(() => {
        attemptLocation();
    }, [locationAccess]);

    const searchMobileFiler = (params: any) => {
        setfilterViews((prs: any) => {
            return {
                ...prs,
                [params]: !prs[params]
            };
        });
    };

    useEffect(() => {

        if (window.innerWidth > 991.98) {
            setfilterViews((prs: any) => {
                return {
                    ...prs,
                    filterView: true,
                    listAndMapView: true
                };
            });
        } else {
            setfilterViews((prs: any) => {
                return {
                    ...prs,
                    filterView: false,
                    listAndMapView: false
                };
            });
        }
    }, []);

    const moveToJobViewPage = (params: any) => {
        if (questionId?.data?.data !== params.id) {
            navigate(`/view/${params.id}`);
        }
        else {
            navigate(`/view/${params.id}/apply-job/from/direct`);
        }
    };

    const renderTemplate34Header = () => {
        const templateName = clientSiteSettings?.templateName;
        const HeaderComponentName = templateName.charAt(0).toUpperCase() + templateName.slice(1).replace(/_/g, "");
        return <Suspense fallback={<></>}>
            {React.createElement(React.lazy(() => import(`../header/clientsMenu/${templateName}/${HeaderComponentName}Header`).catch(() => ({ default: () => <div>Not loading....</div> }))), { filterView: optionFourFilterView })}
        </Suspense>;
    };

    return (

        <>

            <div>
                <Loader loading={loader} />
            </div>
            <>
                {clientDesign === "option4" &&
                    renderTemplate34Header()
                }
            </>
            {/* if not micro site  */}
            {!clientConfig?.data?.data?.clientSettings?.isMicroSite && (
                <div className="wave-bg-how">
                    <h1>Careers</h1>
                </div>
            )}
            <CompletionSubHeader />

            {(() => {
                if (clientDesign === "template_4") {
                    return (
                        <JobListingsClient
                            location={location}
                            clientId={clientConfig?.data?.data?.clientSettings?.clientId}
                            checkListControl={checkListControl}
                            jobsList={jobsList}
                            setTableControl={setTableControl}
                            tableControl={tableControl}
                            sortList={sortList}
                            displayPage={displayPage}
                            filterView={filterView}
                            moveToJobViewPage={moveToJobViewPage}
                            pageChange={pageChange}
                            filterListData={filterListData}
                            searchControlSubmit={searchControlSubmit}
                            pageSizeChange={pageSizeChange}
                            withinDisabled={withinDisabled}
                            withinDisabledLocClass={withinDisabledLocClass}
                            navigateToJobAlerts={navigateToJobAlerts}
                            navigateToJob={navigateToJob}
                        />
                    );
                } else if (clientDesign === "common") {
                    return (
                        <JobListingsSplit
                            location={location}
                            clientId={clientConfig?.data?.data?.clientSettings?.clientId}
                            checkListControl={checkListControl}
                            jobsList={jobsList}
                            searchMobileFiler={searchMobileFiler}
                            filterViews={filterViews}
                            setListView={setListView}
                            listView={listView}
                            setTableControl={setTableControl}
                            tableControl={tableControl}
                            sortList={sortList}
                            pageSizeChange={pageSizeChange}
                            displayPage={displayPage}
                            filterView={filterView}
                            moveToJobViewPage={moveToJobViewPage}
                            publishingDate={publishingDate}
                            pageChange={pageChange}
                            navigateToJob={navigateToJob}
                            clientIds={clientIds}
                            filterListData={filterListData}
                            searchControlSubmit={searchControlSubmit}
                            isMicroSite={clientConfig?.data?.data?.clientSettings?.isMicroSite}
                        />
                    );
                } else if (clientDesign === "option3") {
                    return (
                        <OptionThreeJobListing
                            location={location}
                            clientId={clientConfig?.data?.data?.clientSettings?.clientId}
                            checkListControl={checkListControl}
                            jobsList={jobsList}
                            searchMobileFiler={searchMobileFiler}
                            filterViews={filterViews}
                            setListView={setListView}
                            listView={listView}
                            setTableControl={setTableControl}
                            tableControl={tableControl}
                            sortList={sortList}
                            pageSizeChange={pageSizeChange}
                            displayPage={displayPage}
                            filterView={clientSiteSettings?.classicTemplateFilterView === true ? classicTemplateFilterView : optionThreeFilterView}
                            moveToJobViewPage={moveToJobViewPage}
                            publishingDate={publishingDate}
                            pageChange={pageChange}
                            navigateToJob={navigateToJob}
                            clientIds={clientIds}
                            filterListData={filterListData}
                            searchControlSubmit={searchControlSubmit}
                            isMicroSite={clientConfig?.data?.data?.clientSettings?.isMicroSite}
                            isMapViewEnabled={clientConfig?.data?.data?.clientSettings?.isMapViewEnabled}
                            getListOfJob={getListOfJob}
                        />
                    );
                } else if (clientDesign === "option4") {
                    return (
                        <OptionFourJobListing
                            location={location}
                            clientId={clientConfig?.data?.data?.clientSettings?.clientId}
                            checkListControl={checkListControl}
                            jobsList={jobsList}
                            searchMobileFiler={searchMobileFiler}
                            filterViews={filterViews}
                            setListView={setListView}
                            listView={listView}
                            setTableControl={setTableControl}
                            tableControl={tableControl}
                            sortList={sortList}
                            pageSizeChange={pageSizeChange}
                            displayPage={displayPage}
                            filterView={optionThreeFilterView}
                            moveToJobViewPage={moveToJobViewPage}
                            publishingDate={publishingDate}
                            pageChange={pageChange}
                            navigateToJob={navigateToJob}
                            clientIds={clientIds}
                            filterListData={filterListData}
                            searchControlSubmit={searchControlSubmit}
                            isMicroSite={clientConfig?.data?.data?.clientSettings?.isMicroSite}
                            isMapViewEnabled={clientConfig?.data?.data?.clientSettings?.isMapViewEnabled}
                            getListOfJob={getListOfJob}
                        />
                    );
                } else if (clientDesign === "skyTheme") {
                    return (
                        <Suspense fallback={<></>}>
                            <SkyJobListing
                                location={location}
                                clientId={clientConfig?.data?.data?.clientSettings?.clientId}
                                checkListControl={checkListControl}
                                jobsList={jobsList}
                                searchMobileFiler={searchMobileFiler}
                                filterViews={filterViews}
                                setListView={setListView}
                                listView={listView}
                                setTableControl={setTableControl}
                                tableControl={tableControl}
                                sortList={sortList}
                                pageSizeChange={pageSizeChange}
                                displayPage={displayPage}
                                filterView={skyFilterView}
                                moveToJobViewPage={moveToJobViewPage}
                                publishingDate={publishingDate}
                                pageChange={pageChange}
                                navigateToJob={navigateToJob}
                                clientIds={clientIds}
                                filterListData={filterListData}
                                searchControlSubmit={searchControlSubmit}
                                isMicroSite={clientConfig?.data?.data?.clientSettings?.isMicroSite}
                                isMapViewEnabled={clientConfig?.data?.data?.clientSettings?.isMapViewEnabled}
                                getListOfJob={getListOfJob}
                            />
                        </Suspense>
                    );
                } else if (clientDesign === "editorialMono") {
                    return (
                        <Suspense fallback={<></>}>
                            <EditorialMonoJobListing
                                location={location}
                                clientId={clientConfig?.data?.data?.clientSettings?.clientId}
                                checkListControl={checkListControl}
                                jobsList={jobsList}
                                searchMobileFiler={searchMobileFiler}
                                filterViews={filterViews}
                                setListView={setListView}
                                listView={listView}
                                setTableControl={setTableControl}
                                tableControl={tableControl}
                                sortList={sortList}
                                pageSizeChange={pageSizeChange}
                                displayPage={displayPage}
                                filterView={editorialMonoFilterView}
                                moveToJobViewPage={moveToJobViewPage}
                                publishingDate={publishingDate}
                                pageChange={pageChange}
                                navigateToJob={navigateToJob}
                                clientIds={clientIds}
                                filterListData={filterListData}
                                searchControlSubmit={searchControlSubmit}
                                isMicroSite={clientConfig?.data?.data?.clientSettings?.isMicroSite}
                                isMapViewEnabled={clientConfig?.data?.data?.clientSettings?.isMapViewEnabled}
                                getListOfJob={getListOfJob}
                            />
                        </Suspense>
                    );
                } else if (clientDesign === "glassAurora") {
                    return (
                        <Suspense fallback={<></>}>
                            <GlassAuroraJobListing
                                location={location}
                                clientId={clientConfig?.data?.data?.clientSettings?.clientId}
                                checkListControl={checkListControl}
                                jobsList={jobsList}
                                searchMobileFiler={searchMobileFiler}
                                filterViews={filterViews}
                                setListView={setListView}
                                listView={listView}
                                setTableControl={setTableControl}
                                tableControl={tableControl}
                                sortList={sortList}
                                pageSizeChange={pageSizeChange}
                                displayPage={displayPage}
                                filterView={glassAuroraFilterView}
                                moveToJobViewPage={moveToJobViewPage}
                                publishingDate={publishingDate}
                                pageChange={pageChange}
                                navigateToJob={navigateToJob}
                                clientIds={clientIds}
                                filterListData={filterListData}
                                searchControlSubmit={searchControlSubmit}
                                isMicroSite={clientConfig?.data?.data?.clientSettings?.isMicroSite}
                                isMapViewEnabled={clientConfig?.data?.data?.clientSettings?.isMapViewEnabled}
                                getListOfJob={getListOfJob}
                            />
                        </Suspense>
                    );
                } else if (clientDesign === "option6") {
                    return (
                        <Suspense fallback={<></>}>
                            <OptionSixJobListing
                                location={location}
                                clientId={clientConfig?.data?.data?.clientSettings?.clientId}
                                checkListControl={checkListControl}
                                jobsList={jobsList}
                                searchMobileFiler={searchMobileFiler}
                                filterViews={filterViews}
                                setListView={setListView}
                                listView={listView}
                                setTableControl={setTableControl}
                                tableControl={tableControl}
                                sortList={sortList}
                                pageSizeChange={pageSizeChange}
                                displayPage={displayPage}
                                moveToJobViewPage={moveToJobViewPage}
                                publishingDate={publishingDate}
                                pageChange={pageChange}
                                navigateToJob={navigateToJob}
                                clientIds={clientIds}
                                filterListData={filterListData}
                                searchControlSubmit={searchControlSubmit}
                                isMicroSite={clientConfig?.data?.data?.clientSettings?.isMicroSite}
                                isMapViewEnabled={clientConfig?.data?.data?.clientSettings?.isMapViewEnabled}
                                getListOfJob={getListOfJob}
                            />
                        </Suspense>
                    );
                } else if (clientDesign === "premium") {
                    return (
                        <Suspense fallback={<></>}>
                            <PremiumJobListing
                                location={location}
                                clientId={clientConfig?.data?.data?.clientSettings?.clientId}
                                checkListControl={checkListControl}
                                jobsList={jobsList}
                                searchMobileFiler={searchMobileFiler}
                                filterViews={filterViews}
                                setListView={setListView}
                                listView={listView}
                                setTableControl={setTableControl}
                                tableControl={tableControl}
                                sortList={sortList}
                                pageSizeChange={pageSizeChange}
                                displayPage={displayPage}
                                filterView={optionThreeFilterView}
                                moveToJobViewPage={moveToJobViewPage}
                                publishingDate={publishingDate}
                                pageChange={pageChange}
                                navigateToJob={navigateToJob}
                                clientIds={clientIds}
                                filterListData={filterListData}
                                searchControlSubmit={searchControlSubmit}
                                isMicroSite={clientConfig?.data?.data?.clientSettings?.isMicroSite}
                                isMapViewEnabled={clientConfig?.data?.data?.clientSettings?.isMapViewEnabled}
                                getListOfJob={getListOfJob}
                            />
                        </Suspense>
                    );
                } else {
                    return null;
                }
            })()}


        </>
    );
};

export default JobListings;